module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="lottery-button-container js-open-lottery">\n    <div class="lottery-button-container__icon"></div>\n\n    <label class="lottery-button-container__label">\n        Розыгрыш\n    </label>\n</div>';
}
return __p;
};
